module.exports = __webpack_public_path__ + "static/media/iconLibrarySchoolActive.c6f535df.svg";